import { useRovoEntitlementResource } from '@jira/router-resources__rovo-entitlement/src/useRovoEntitlementResource.tsx';
import { fg } from '@atlassian/jira-feature-gating';

export const useAiPlannerUniversalCreateEnabled = (): boolean => {
	const { data: rovoEntitlementData } = useRovoEntitlementResource();
	// TODO: Add Planner provisioning checks
	return (
		rovoEntitlementData?.isRovoLLMEnabled === true &&
		rovoEntitlementData?.isBetaAiFeaturesEnabled === true &&
		fg('jira_planner_uc_enabled')
	);
};
